<template lang="pug">
  .wrap
    page-title Manage your Users

    list-header(:on-search='search' search-placeholder='Search by email, name, phone number...')
      template(slot='action')
        router-link(slot='action' :to="{ name: 'companyAdmin:userCreate' }")
          el-button(type="primary") Add New User

        router-link(:to="{ name: 'companyAdmin:userImport' }")
          el-button(type="primary" :style='{ marginLeft: "10px" }') Import...

      el-select(slot='extraSearch' v-model='filterByGroupId' @change='filterChanged' placeholder='Filter by' clearable :loading='loadingFilters' @visible-change.once='filterToggle')
        el-option(v-for='licenseGroup in appLicenseGroups' :key='licenseGroup.group.id' :value='licenseGroup.group.id' :label='licenseGroup.group.name')

    el-table(:data="list.results" empty-text="No entries" v-loading='loading' @sort-change='changeSort'
             highlight-current-row)

      el-table-column(label="Active account" width="100px" align="center")
        template(slot-scope="scope")
          el-icon.icon-check(v-if="scope.row.isActive" name="circle-check")
          el-icon.icon-cross(v-else name="circle-cross")

      el-table-column(label="First name" sortable prop='first_name')
        template(slot-scope="scope") {{ scope.row.user.firstName }}

      el-table-column(label="Last name" sortable prop='last_name')
        template(slot-scope="scope") {{ scope.row.user.lastName }}

      el-table-column(label="Email" sortable prop='email')
        template(slot-scope="scope") {{ scope.row.user.email }}

      el-table-column(label="Groups")
        template(slot-scope="scope")
          el-tag(type="primary" v-for='group in extractGroups(scope.row.user)' :key='group.id')
            | {{ group.name }}

      el-table-column(label="Company admin" width="80px" align="center")
        template(slot-scope="scope")
          el-icon.icon-check(v-if="scope.row.isCompanyAdmin" name="circle-check")
          el-icon.icon-cross(v-else name="circle-cross")

      el-table-column(width='120' align='center')
        template(slot-scope="scope")
          el-button(size='small' @click='navigateToUserDetail(scope.row.id)')
            icon.report-icon(name='edit' color='#999')
            | Edit

    .pages
      el-pagination(layout="prev, pager, next" @current-change='changePage' :total="list.count" :page-size='pageSize')

</template>

<script>
import _ from "lodash";
import { mapActions } from "vuex";
import PageTitle from "@/shared/components/layout/PageTitle";
import ListHeader from "@/shared/components/ListHeader";

export default {
  components: { PageTitle, ListHeader },
  name: "UserList",
  data() {
    return {
      loading: false,
      loadingFilters: false,
      pageSize: 20,
      searchParams: null,
      list: {
        retults: [],
        count: 0
      },
      appLicenseGroups: [],
      filterByGroupId: null
    };
  },
  methods: {
    ...mapActions({
      fetchUsers: "companyUsers/fetchCompanyUsers",
      fetchAppLicenseGroups: "appLicenseGroups/fetch"
    }),
    loadList({ params } = {}) {
      const mergedParams = {
        pageSize: this.pageSize,
        sort: "first_name",
        ...params
      };
      this.loading = true;
      this.fetchUsers({ params: mergedParams }).then(data => {
        this.list = data;
        this.loading = false;
      });
    },
    navigateToUserDetail(userId) {
      this.$router.push({ name: "companyAdmin:userEdit", params: { userId } });
    },
    extractGroups(user) {
      return _.filter(
        user.appLicenseGroupUsers.map(lgu =>
          _.get(lgu, "appLicenseGroup.group")
        )
      );
    },
    search(q) {
      this.loadList({ params: { q } });
    },
    filterToggle(open) {
      if (!open) {
        return;
      }
      this.fetchAppLicenseGroups().then(data => {
        this.appLicenseGroups = data;
      });
    },
    filterChanged(groupId) {
      const params = groupId ? { group: groupId } : {};
      this.loadList({ params });
    },
    changeSort({ prop, order }) {
      if (!order) {
        this.loadList();
        return;
      }
      const sortVal = (order === "ascending" ? "" : "-") + prop;
      this.loading = true;
      this.loadList({ params: { sort: sortVal } });
    },
    changePage(page) {
      this.loadList({ params: { page } });
    }
  },
  created() {
    this.loadList();
  }
};
</script>

<style scoped lang="scss">
.wrap {
  :global(.cell) {
    word-break: normal;
    line-height: 20px;
    padding: 10px 0;
  }
}

.report-icon {
  margin-right: 8px;
}

.pages {
  margin-top: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
